export enum EventsSort {
    TIMESTAMP_ASC = 'timestamp',
    CARRIER_NAME_ASC = 'carrier',
    ORIGIN_ASC = 'origin',
    SPEED_ASC = 'value',
    DURATION_ASC = 'metadata.duration',
    DRIVER_ASC = 'driverName',
    VEHICLE_ASC = 'identification.value',
    VEHICLE_NAME_ASC = 'vehicleName',
    TIMESTAMP_DESC = '-timestamp',
    CARRIER_NAME_DESC = '-carrier',
    ORIGIN_DESC = '-origin',
    SPEED_DESC = '-value',
    DURATION_DESC = '-metadata.duration',
    DRIVER_DESC = '-driverName',
    VEHICLE_DESC = '-identification.value',
    VEHICLE_NAME_DESC = '-vehicleName',
}
